import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../tailwind.config.js';

import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import CustomEase from 'gsap/CustomEase';
gsap.registerPlugin(ScrollTrigger, CustomEase);

const EASE1 = '0.77, 0, 0.175, 1';
//const EASE1 = '0.645, 0.045, 0.355, 1';
// const EASE2 = '0.45, 0.03, 0.51, 0.91';CustomEase.create('ease1', EASE1);
const EASE2 = '0.25, 0.46, 0.45, 0.94';
const SLIDER_EASE = 'M0,0 C0.266,0.412 0.529,0.762 0.658,0.883 0.702,0.924 0.78,1 1,1';
const DESKTOP_SCRUB = 0.8;
const MOBILE_SCRUB = 0.1;

const screenSm = parseFloat(resolveConfig(tailwindConfig).theme.screens.sm);

class AnimationDefaults {
    constructor() {
        this._run();
    }
    _run = () => {
        this._media = gsap.matchMedia();

        this._media.add(
            {
                isDesktop: `(min-width: ${screenSm}px)`,
                isMobile: `(max-width: ${screenSm - 1}px)`,
                reduceMotion: '(prefers-reduced-motion: reduce)',
            },
            this._createAnimationDefaults,
        );
    };
    _createAnimationDefaults = (context) => {
        let { isDesktop, isMobile, reduceMotion } = context.conditions;

        CustomEase.create('ease1', EASE1);
        CustomEase.create('ease2', EASE2);
        CustomEase.create('sliderEase', SLIDER_EASE);
        ScrollTrigger.defaults({
            scrub: isDesktop ? DESKTOP_SCRUB : MOBILE_SCRUB,
        });

        gsap.timeline({
            defaults: {
                ease: isDesktop ? 'power3.out' : 'power2.out',
                //overwrite: 'auto',
            },
        });
    };
}

const animationDefaults = new AnimationDefaults();

export { gsap, ScrollTrigger, CustomEase, screenSm };
